import type { NextStep } from '@klear/schema/document-review-step'

export const NEXT_STEP_LABELS: Record<NextStep, string> = {
  readyToApprove: 'Ready to create',
  waitingOnYou: 'Waiting on you',
  waitingOnParent: 'Waiting on the parent',
  blocked: 'Blocked',
  processing: 'Processing',
  creatingRecords: 'Creating records',
  notProcessed: 'Not processed',
  filed: 'Filed',
  filedAutomatically: 'Filed',
  dismissed: 'Dismissed',
  filedByLaterRun: 'Filed by a later run',
  superseded: 'Replaced by another run'
}
